<template>
  <section class="pt-24">
    <div v-if="!state.isSubmitted">
      <span
        class="block text-gray-92 text-center font-light text-lg leading-8 py-4 mb-4"
        style="margin-top: 56px"
        >ご登録のメールアドレスに、パスワード再設定のご案内をお送りします。</span
      >
      <div
        class="bg-white mx-auto mb-4 rounded-lg"
        style="max-width: 560px; padding: 32px 60px; margin-bottom: 288px"
      >
        <Form
          :validateOnMount="true"
          v-slot="{ handleSubmit, meta, errors }"
          :validation-schema="state.validationSchema"
          as="div"
        >
          <form @submit="handleSubmit($event, onSubmit)">
            <div class="mb-8">
              <label for="email">
                <img
                  src="@/assets/icons/Mail.svg"
                  class="absolute z-10 ml-3 mt-2"
                />
                <Field
                  :validateOnInput="true"
                  as="input"
                  type="email"
                  name="email"
                  id="email"
                  class="relative block min-w-full pl-12 pr-4 py-3 border rounded leading-4"
                  :class="{
                    'border-danger': state.isDirty['email'] && errors.email,
                  }"
                  v-model="state.email"
                  placeholder="メールアドレス"
                  @input="setIsDirty('email')"
                  @blur="setIsDirty('email')"
                />
              </label>
              <ErrorMessage
                v-if="state.isDirty['email']"
                name="email"
                as="span"
                class="text-danger"
              />
            </div>
            <button
              type="submit"
              class="block mx-auto font-semibold text-white rounded hover:button focus:outline-none"
              :class="{
                'bg-secondary-main hover:button': meta.valid,
                'bg-slate-300': !meta.valid,
              }"
              style="width: 200px; height: 40px"
            >
              送信
            </button>
          </form>
        </Form>
      </div>
    </div>
    <div v-else class="text-center">
      <div
        class="leading-7 text-gray-92 font-semibold text-lg"
        style="margin: 27px auto 34px"
      >
        <span class="block">パスワード再設定のご案内をお送りしました。</span>
        <span class="block">24時間以内に再設定を行ってください。</span>
      </div>
      <div
        class="leading-7 text-gray-92 text-base"
        style="margin: 34px auto 55px; font-size: 14px"
      >
        <span class="block"
          >ご案内のメールが届かない場合は、入力したメールアドレスが</span
        >
        <span class="block"
          >間違っている可能性がございます。もう一度お試しください。</span
        >
      </div>
      <router-link
        :to="{ name: 'Login' }"
        class="text-white bg-secondary-main rounded"
        style="margin-bottom: 400px; padding: 10px 45px"
        >ログインページへ</router-link
      >
    </div>
  </section>
</template>

<script>
import { reactive, inject } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import axios from '@/utils/axiosAuth.js';
import rules from '@/utils/validateRules.js';

export default {
  props: {},
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  setup() {
    const globalMethods = inject('globalMethods');

    const state = reactive({
      isSubmitted: false,
      email: '',
      validationSchema: {
        email(value) {
          const result = rules.validate(value, 'required|email');
          return result === true ? true : result;
        },
      },
      isDirty: {},
    });
    const setIsDirty = (key) => {
      state.isDirty[key] = true;
    };
    const onSubmit = async () => {
      const data = { email: state.email };
      await axios
        .post('/users/password/request', data)
        .then(() => {
          state.isSubmitted = true;
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    };

    return {
      state,
      setIsDirty,
      onSubmit,
    };
  },
};
</script>

<style lang="scss" scoped></style>
